import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import AppDialog from '@/components/AppDialog.vue';

var AppNav = /*#__PURE__*/function (_Vue) {
  _inherits(AppNav, _Vue);

  var _super = _createSuper(AppNav);

  function AppNav() {
    var _this;

    _classCallCheck(this, AppNav);

    _this = _super.apply(this, arguments);
    _this.version = process.env.VUE_APP_VERSION;
    _this.dialog = false;
    return _this;
  }

  _createClass(AppNav, [{
    key: "signOut",
    value: function signOut() {
      this.dialog = true;
    }
  }, {
    key: "signOutHandler",
    value: function signOutHandler() {
      this.dialog = false;
      localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY);
      this.$router.replace({
        name: 'SignIn'
      });
    }
  }]);

  return AppNav;
}(Vue);

__decorate([State(function (state) {
  return state.user.me;
})], AppNav.prototype, "me", void 0);

AppNav = __decorate([Component({
  components: {
    AppDialog: AppDialog
  }
})], AppNav);
export default AppNav;